var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radio-button"},[_c('input',{staticClass:"radio-button__input",attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.value},on:{"input":_vm.toggleChecked}}),_vm._v(" "),_c('div',{staticClass:"radio-button__checkmark",class:{
      'radio-button__checkmark--checked': _vm.checked,
      'radio-button__checkmark--disabled': _vm.disabled,
    }})])
}
var staticRenderFns = []

export { render, staticRenderFns }